import postAPI from './postAPI.js'

export default async function postInitiateStepPayment(body) {
    const data = await postAPI('taskinstances/steps/payment/initiate', body);
    return data;
}
